// try_speed/get_info
function getTrySpeedInfo (url: string) {
  // console.log('mock:', url)
  return Promise.resolve({
    data: {
      'status': -1,
      'usage': {
        'total': 0,
        'used': 0,
      },
      'count_down': {
        'total': 0,
        'used': 0,
      },
      'task_counter': {
        'super_speed': null,
        'team': null,
      },
      'statistic': {
        'average_speed': 0,
        'saved_sec': 0,
        'start_time': 0,
        'end_time': 0,
        'stop_reason': '',
      },
      'expire_sec': 0,
    },
  })
}
// device/v1/get_config
// device/v1/try_speed/get_config
function getDeviceConfig (url: string) {
  // console.log('mock:', url)
  return Promise.resolve({
    data: {
      'file_play_by_scene': {
        'download_list': {
          'total_count_by_vastype': {
            '0': -1,
            '3': -1,
            '5': -1,
          },
          'is_disabled': false,
          'total_count': -1,
          'used_count': 0,
        },
        'nfo': {
          'total_count_by_vastype': {
            '0': 1,
            '3': 3,
            '5': -1,
          },
          'is_disabled': false,
          'total_count': -1,
          'used_count': 0,
        },
      },
      'nfo_config': {
        'is_disabled': false,
      },
    },
  })
}
// device/info/watch
function getDeviceInfoWatch (url: string, params) {
  console.log('mock:', url, params)
  return Promise.resolve({
    data: {
      'device_space': params.device_space,
      'downloads': [{
        'name': '/var/packages/pan-xunlei-com/shares/迅雷/下载',
        'path': '/var/packages/pan-xunlei-com/shares/迅雷/下载',
        'usage': 87682240512,
        'limit': 201004470272,
        'errmsg': '',
        'is_root_path': false,
      }, {
        'name': '/volume1',
        'path': '/volume1',
        'usage': 87682240512,
        'limit': 201004470272,
        'errmsg': '',
        'is_root_path': true,
      }],
      'user': params.user || {
        'name': '176****6171',
        'id': '827350621',
        'picture': 'https://xfile2.a.88cdn.com/file/k/avatar/default',
        'vip': {
          'is_vip': true,
          'level': 2,
          'vastype': '5',
          'isyear': true,
        },
        'group': [{
          'id': 'vip_1_2_5',
          'expires_at': '2024-03-06T16:00:00Z',
        }],
      },
      'runner_status': {
        'status': '',
        'message': {
          'messages': null,
          'url': '',
          'url_title': '',
          'title': '',
          'just_one': false,
        },
        'expire_config': {
          'expire_time': '2042-11-16T20:53:18.000+08:00',
          'reg_is_expire': '',
        },
      },
      'task_daily_limit': {
        'messages': ['\u003ca class="nas-user__vip-link" target="_blank" href="paycenter"\u003e开通会员\u003c/a\u003e即可享受任务无限次下载'],
        'url': '',
        'url_title': '',
        'title': '今日3个免费下载任务数已用完，开通会员不限次数',
        'just_one': false,
      },
      'login_message': {
        'messages': ['1. 该版本仅为内测版，拥有内测邀请码才可以使用', '2. 手机控制：使用迅雷App登录相同迅雷账号即可', '3. 如二维码加载失败，请更换其他浏览器尝试，推荐Chrome', '4. NAS迅雷用户QQ群：772445453\u003ca href="https://docs.qq.com/doc/DQWZSTWtVU1llTnBW"\u003e常见问题\u003c/a\u003e'],
        'url': '',
        'url_title': '',
        'title': '迅雷App扫码登录',
        'just_one': false,
      },
      'target': params.device_space || 'device_id#65a62647db4d757b3c57b00e5918b088',
      'privilege': 'PAN_CLI_PREVIEW',
      'product_name': '群晖',
      'create_privilege_code': 'PAN_CLI_PREVIEW',
      'labels': ['withQrcodeLogin', 'withOtherAuthLogin', 'withPlugin', 'withPreviewPrivilege', 'allowUseConfigPathAsCachePath', 'withRootDiskSelect'],
      'build_version': '45d5586a',
      'download_version': '8.1014.160.25',
      'is_connected': true,
      'last_update_time': '2022-12-05T10:39:34.144+08:00',
      'download_running': false,
      'client_version': '3.1.5',
      'contact': 'NAS迅雷-群晖用户QQ群：772445453\u0026nbsp;\u0026nbsp;|\u0026nbsp;\u0026nbsp;\u003ca target="_blank" href="https://docs.qq.com/doc/DQWZSTWtVU1llTnBW"\u003e常见问题\u003c/a\u003e',
      'ntp_time': '2022-12-05T14:19:07.000+08:00',
      'plugin_banner': {
        'h5': [{
          'preview': 'https://backstage-img-ssl.a.88cdn.com/20ffb36cb407d05fe2a110139865009fbf6d0bd7',
          'url': '',
        }, {
          'preview': 'https://backstage-img-ssl.a.88cdn.com/411b114f64228b9be346e2a34bc3fabe3e7faabe',
          'url': 'https://help.onethingcloud.com/lease/f84f',
        }],
        'pc': [{
          'preview': 'https://backstage-img-ssl.a.88cdn.com/1325fc77edc6f2e4fec5a411adef2a74881a832b',
          'url': ' ',
        }, {
          'preview': 'https://backstage-img-ssl.a.88cdn.com/e05eff686a28a919174b9a58870cd163c9112fc2',
          'url': 'https://help.onethingcloud.com/lease/f84f',
        }],
      },
      'download_guide': 'https://docs.qq.com/doc/DV3N3VHJCU2lmYk54',
      'root_alias': null,
    },
  })
}

// device/v1/nfo/dirs
function getDeviceNfoDirs () {
  return Promise.resolve({ 'dirs': [{ 'real_path': '/var/packages/pan-xunlei-com/shares/迅雷/下载/' }] })
}

// /drive/v1/apps/INNER_API
function getInnerApi () {
  return Promise.resolve([null, {
    link: 'https://api-hezi.xunlei.com', 
    name: '内网api穿透专用',
  }])
}

// /drive/v1/privilege/PAN_CLI_FULL
function getPrivilegePAN_CLI_FULL () {
  return Promise.resolve([null, { 'result': 'REJECTED', 'message': '', 'redirect_uri': '', 'data': {} }])
}
// drive/v1/privilege/PAN_CLI_FULL
function getPrivilegePAN_CLI_PREVIEW () {
  return Promise.resolve([null, { 'result': 'ACCEPTED', 'message': '', 'redirect_uri': '', 'data': { 'expireTime': '2042-06-08T15:20:27.000+08:00' } }])
}
// device/download_path
function getDeviceDownloadPath () {
  return Promise.resolve([null, {  }])
}
// drive-reverse-proxy/v1/proxyToken
function getproxyToken () {
  return Promise.resolve([null, {
    'status': 0,
    'usage': {
      'total': 3,
      'used': 0,
    },
    'count_down': {
      'total': 0,
      'used': 0,
    },
    'task_counter': {
      'super_speed': null,
      'team': null,
    },
    'statistic': {
      'average_speed': 0,
      'saved_sec': 0,
      'start_time': 0,
      'end_time': 0,
      'stop_reason': '',
    },
    'expire_sec': 10,
  }])
}

export function mock ({config, response} : { config: { url: string; params:any }; response: unknown }) {
  const map = {
    'api-hezi.xunlei.com/device/v1/try_speed/get_info': getTrySpeedInfo,
    'api-hezi.xunlei.com/device/v1/get_config': getDeviceConfig,
    'api-hezi.xunlei.com/device/v1/try_speed/get_config': getDeviceConfig,
    'api-hezi.xunlei.com/device/info/watch': getDeviceInfoWatch,
    'api-hezi.xunlei.com/device/v1/nfo/dirs': getDeviceNfoDirs,
    'api-hezi.xunlei.com/drive/v1/apps/INNER_API': getInnerApi,
    'api-hezi.xunlei.com/drive/v1/privilege/PAN_CLI_FULL': getPrivilegePAN_CLI_FULL,
    'api-hezi.xunlei.com/drive/v1/privilege/PAN_CLI_PREVIEW': getPrivilegePAN_CLI_PREVIEW,
    'api-hezi.xunlei.com/device/download_path': getDeviceDownloadPath,
    'api-hezi.xunlei.com/drive-reverse-proxy/v1/proxyToken': getproxyToken,
  }
  const targetKey = Object.keys(map).find(key => config.url?.includes(key))
  if (targetKey && map[targetKey]) {
    return map[targetKey](config.url, config.params).then(res => ({ config, response: res }))
  } else {
    return { config, response }
  }
}